import moment from 'moment';
import "moment-timezone"


const eventStatusButtonText = (status, isApprover) => {
  switch (status) {
    case 'published':
      return 'schedule invite';
    case 'publish_scheduled':
      return 'publish now';
    case 'archived':
      return 'unarchive';
    case 'canceled':
      return 'duplicate';
    default:
      return isApprover ? 'review event' : 'edit';
  }
};

const sortingIndex = (key) => {
  return parseInt(key.split("-")[0]) * 12 + parseInt(key.split('-')[1]);
};

const eventsSorting = (a, b) => {
  if (new Date(a.node.startAt) === new Date(b.node.startAt))
    return new Date(b.node.endAt) - new Date(a.node.endAt);
  else
    return new Date(b.node.startAt) - new Date(a.node.startAt);
};

const getStatus = (status) => {
  switch (status) {
    case 'to_be_approved':
      return 'To Be Approved';
    case 'publish_scheduled':
      return 'Scheduled For Publish';
    case 'invite_scheduled':
      return 'Scheduled For Invite';
    default:
      return status;
  }
};

export const eventsGroupSorting = (a, b) => {
  return sortingIndex(b.key) - sortingIndex(a.key);
};

export const groupByMonth = (event, timezoneString, array) => {
  let byMonth = {};
  let d = moment(new Date(event["node"]["startAt"])).tz(timezoneString);
  byMonth["key"] = d.format("YYYY-") + d.month();
  byMonth['event'] = event;
  return byMonth;
};

export const setEventsProp = (events, key, isApprover, timezoneString) => {
  let now = moment(new Date().toISOString()).tz(timezoneString);
  return events.sort(eventsSorting).map((event) => {
    let startAt = moment(event.node.startAt).tz(timezoneString);
    return {
      ...event.node,
      monthYear: key,
      id: event.node.id,
      btnText: eventStatusButtonText(event.node.status, isApprover),
      confirmedGuests: event.node.rsvpedCount,
      // endTime: moment.tz(event.node.endAt, timezone).format('h:mm A'),
      endTime: moment(event.node.endAt).tz(timezoneString).format('h:mm a'),
      eventTitle: event.node.title,
      // startTime: new Date(event.node.startAt).toLocaleTimeString(navigator.language, {
      //   hour: '2-digit',
      //   minute: '2-digit'
      // }),
      startTime: startAt.format("h:mm a"),
      //startTime: moment.tz(event.node.startAt, timezone).format('h:mm A'),
      status: getStatus(event.node.status),
      totalGuests: event.node.maxNoOfGuests,
      weekday: startAt.format("ddd, MMM D"),
      //weekday: moment.tz(event.node.startAt, timezone).format('ddd, D MMM YYYY'),
      publishAt: moment(event.node.publishAt).tz(timezoneString),
      //publishAt: moment.tz(event.node.publishAt, timezone),
      inviteScheduledAt: moment(event.node.inviteScheduledAt).tz(timezoneString),
      //inviteScheduledAt: moment.tz(event.node.inviteScheduledAt, timezone),
      publishTime: event.node.publishAt,
      upcoming: startAt.isBefore(now) ? false : true,
      //upcoming: moment.tz(event.node.startAt, timezone).isBefore(now) ? false : true
    }
  })
};


export const capitalize = (input) => {
  var words = input.split('_');
  var CapitalizedWords = [];
  words.forEach(element => {
    CapitalizedWords.push(element[0].toUpperCase() + element.slice(1, element.length));
  });
  return CapitalizedWords.join(' ');
}


export const sortingTableData = (key, _tableData, orderType, isListView) => {
  let tableData = [..._tableData]
  if (tableData.lenght < 2) return tableData;
  let i = 0;
  while (i < tableData.length - 1) {
    let temp = !isListView ? tableData[i] : tableData[i].node;
    let k = i;
    for (let j = k; j < tableData.length; j++) {
      let _tableItem = !isListView ? tableData[j] : tableData[j].node;
      if (orderType == "asc") {
        if (_tableItem[key] < temp[key]) {
          temp = _tableItem;
          k = j;
        }
      } else {
        if (_tableItem[key] > temp[key]) {
          temp = _tableItem;
          k = j;
        }
      }
    }
    if (i != k) {
      let copy = tableData[k];
      tableData[k] = tableData[i];
      tableData[i] = copy;
    }
    i++;
  }
  return tableData
}